// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__8rKg4","col":"styles_col__2hPfm"};